import { useIntl } from 'react-intl';
import { DictionaryEvidence, TableCells, TableColumn } from '@eas/common-web';
import { OperationType } from '@models';

export function useColumns(): TableColumn<OperationType>[] {
  const intl = useIntl();

  const dictionaryColumns =
    DictionaryEvidence.useDictionaryColumns<OperationType>();

  return [
    dictionaryColumns.columnName,
    {
      datakey: 'revisionUnitType.name',
      sortkey: 'revisionUnitType.name',
      filterkey: 'revisionUnitType.name',
      name: intl.formatMessage({
        id: 'ZSD__OPERATION_TYPE__TABLE__COLUMN__REVISION_UNIT_TYPE',
        defaultMessage: 'Typ revíznej jednotky',
      }),
      sortable: true,
      filterable: true,
      width: 150,
      CellComponent: TableCells.TextCell,
    },
  ];
}
